import React from 'react';
import styles from '../../styles/formComponent/RadioComponent.module.scss';

const RadioComponent = ({
  label,
  name,
  value,
  checked,
  onChange,
  onBlur,
  onFocus,
  required = false,
  disabled = false,
  error,
  helperText,
  size = 'medium',
  color = 'primary',
  description,
  className = '',
  options = [], // Array of radio options
  direction = 'horizontal', // 'vertical' or 'horizontal'
  ...props
}) => {
  const handleChange = (optionValue) => {
    if (onChange) {
      const event = {
        target: {
          name,
          value: optionValue,
          type: 'radio'
        }
      };
      onChange(event);
    }
  };

  const renderSingleRadio = (option, index) => {
    const isChecked = value === option.value;
    const radioId = `${name}_${index}`;
    const isOptionDisabled = disabled || option.disabled;

    return (
      <div 
        key={option.value || index}
        className={`${styles.radioItem} ${isOptionDisabled ? styles.disabled : ''}`}
      >
        <input
          type="radio"
          id={radioId}
          name={name}
          value={option.value}
          checked={isChecked}
          onChange={() => !isOptionDisabled && handleChange(option.value)}
          onBlur={onBlur}
          onFocus={onFocus}
          disabled={isOptionDisabled}
          required={required}
          className={`${styles.radioInput} ${styles[size]} ${styles[color]}`}
          {...props}
        />
        <label 
          htmlFor={radioId}
          className={`${styles.radioLabel} ${isChecked ? styles.checked : ''} ${isOptionDisabled ? styles.disabled : ''}`}
        >
          <span className={styles.radioButton}>
            <span className={styles.radioInner} />
          </span>
          <span className={styles.labelText}>
            {option.label}
            {option.description && (
              <span className={styles.optionDescription}>{option.description}</span>
            )}
          </span>
        </label>
      </div>
    );
  };

  return (
    <div className={`${styles.radioWrapper} ${className}`}>
      {label && (
        <div className={`${styles.radioGroupLabel} ${required ? styles.required : ''}`}>
          {label}
          {required && <span className={styles.requiredIndicator}>*</span>}
        </div>
      )}
      
      {description && (
        <div className={styles.description}>{description}</div>
      )}

      <div className={`${styles.radioGroup} ${styles[direction]}`}>
        {options.map((option, index) => renderSingleRadio(option, index))}
      </div>

      {(error || helperText) && (
        <div className={`${styles.helperText} ${error ? styles.error : ''}`}>
          {error || helperText}
        </div>
      )}
    </div>
  );
};

export default RadioComponent;